
import React from "react";
import { Input } from "@/components/ui/input";
import { UnitSelector } from "./UnitSelector";
import { format } from "date-fns";

interface DeadlineInputProps {
  enabled: boolean;
  timeValue: string;
  timeUnit: "hours" | "days";
  inputError: string | null;
  eventDeadline: Date | null;
  onTimeChange: (value: string) => void;
  onInputBlur: () => void;
  onUnitChange: (unit: "hours" | "days") => void;
}

export function DeadlineInput({
  enabled,
  timeValue,
  timeUnit,
  inputError,
  eventDeadline,
  onTimeChange,
  onInputBlur,
  onUnitChange
}: DeadlineInputProps) {
  if (!enabled) return null;

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Input 
          type="text" 
          value={timeValue} 
          onChange={e => onTimeChange(e.target.value)} 
          onBlur={onInputBlur} 
          className={`w-20 ${inputError ? "border-red-500" : ""}`} 
          aria-invalid={!!inputError} 
        />
        <UnitSelector 
          currentUnit={timeUnit}
          onUnitChange={onUnitChange}
        />
      </div>
      
      {inputError && <p className="text-sm text-red-500">{inputError}</p>}
      
      {eventDeadline && <p className="text-sm text-muted-foreground">
          Deadline: {format(eventDeadline, "MMM d, yyyy 'at' h:mm a")}
        </p>}
    </div>
  );
}
